import { useState } from "react";
import React from "react";
import { ComposedModal, Button, Tabs, Tab, ModalBody, ModalFooter, ModalHeader, Header, Grid, Row, Column, Modal } from "carbon-components-react";

function LifeInsurancePlanDetails() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <ComposedModal open={open} onClose={() => setOpen(false)}>
        <ModalHeader className="mt-6 mb-2 -ml-4">
          <p className=" text-2xl">Life Insurance Plan Details</p>
          <p>Standard Basic Life and Accidental Death and Dismemberment (AD&D)</p>
        </ModalHeader>
        <ModalBody aria-label="Plan Details">
          <div className="-ml-10 px-4 sm:-ml-4 sm:mr-16">
          <div className="bg-gray-200 mb-4 ">
            <Grid>
              <Row>
                <Column className="text-red-600 font-bold mt-2">Group Employee & Dependent Life</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Employee Benefit</Column>
                <Column className="mt-2 mb-2">
                  <span className="font-bold">100% Employer Paid</span>
                </Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Spouse Benefit</Column>
                <Column className="mt-2 mb-2">$5,000</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Child Benefit up to 6 Months</Column>
                <Column className="mt-2 mb-2">$1,000</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Child Benefit 6 months to 21/25</Column>
                <Column className="mt-2 mb-2">$2,500</Column>
              </Row>
            </Grid>
          </div>
          <div className="bg-gray-200 mb-4 ">
            <Grid>
              <Row>
                <Column className="text-red-600 font-bold mt-2">Voluntary Life</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Employee Benefit</Column>
                <Column className="mt-2 mb-2">Increments of $10,000 to a maximum of $500,000 or 5 X Annual Salary</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Guarantee Issue Amount</Column>
                <Column className="mt-2 mb-2">$200,000</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Spouse Benefit</Column>
                <Column className="mt-2 mb-2">Increments of $5,000 to a maximum of $250,000 or 50% of EE Amount</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Guarantee Issue Amount</Column>
                <Column className="mt-2 mb-2">$50,000</Column>
              </Row>
              <Row>
                <Column className="mt-2 mb-2">Child Benefit</Column>
                <Column className="mt-2 mb-2">Increments of $5,000 up to a maximum of $10,000</Column>
              </Row>
            </Grid>
          </div>
          </div>
          <div className="-ml-2 sm:ml-0">
            <p className="mb-2 mt-6">
              <span className="font-bold text-red-600">Group Employee & Dependent Life - Important Information</span>
            </p>
            <ul className="list-outside list-disc px-2 sm:pl-4">
              <li >If your death is a result of an accidental death, your beneficiary will receive double the amount of your Basic Life Insurance from the AD&D plan</li>
              <li >Age Reductions Apply. At age 70 to 65%, at age 75+, amounts reduce to 45% Spouse coverage terminated at age 70. Coverage terminates at Retirement</li>
              <li >Living Care / Accelerated Death Benefit is included. 75% of the amount of the life insurance benefit is available to you if you are terminally ill.</li>
              <li >Conversion is included. If your employment ends, you may apply for an individual policy from Standard without having to provide evidence of insurability (information about your health). You will be responsible for the premium for this coverage and you must contact Standard within 30 days from your last day of coverage.</li>
              <li >Dependent Children may be covered to age 26.</li>
              <li >Your domestic partner and their children may be eligible for this plan. Please see Employee Relations for more details.</li>
            </ul>
          </div>
          <div className="mb-8 -ml-2 sm:ml-0">
            <p className="mb-2 mt-6">
              <span className="font-bold text-red-600">Voluntary Life - Important Information</span>
            </p>
            <ul className="list-outside list-disc px-2 sm:pl-4">
              <li>Any amounts over the Guarantee Issue Amount must be underwritten.</li>
              <li>Your domestic partner and their children may be eligible for this plan. Please see Employee Relations for more details.</li>
            </ul>
          </div>
        </ModalBody>
      </ComposedModal>

      <Button kind="ghost" onClick={() => setOpen(true)}>
        View Plan Details
      </Button>
    </>
  );
}

export default LifeInsurancePlanDetails;
